const STORAGE_KEY_COURSE_DRAFT = 'course_draft';
const STORAGE_KEY_USED_TRAINERS = 'used_trainers';

export default {
    getDraft() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY_COURSE_DRAFT));
        } catch (_) {
            return null;
        }
    },
    setDraft(draft) {
        localStorage.setItem(STORAGE_KEY_COURSE_DRAFT, JSON.stringify(draft));
    },
    removeDraft() {
        localStorage.removeItem(STORAGE_KEY_COURSE_DRAFT);
    },
    getUsedTrainers() {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY_USED_TRAINERS));
        } catch (_) {
            return null;
        }
    },
    setUsedTrainers(value) {
        localStorage.setItem(STORAGE_KEY_USED_TRAINERS, JSON.stringify(value));
    },
};



// WEBPACK FOOTER //
// ./src/store/course/storage.js